<!-- 货物采购 -->
<template>
  <div>
        <ctrl-box class="ctrl-box">
            <template>
                <div class="xgroup">
                    <el-link :underline="false" @click="list">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-shuaxin1" font-size="27px;"/>
                            <span class="txt" >{{msg('刷新')}}</span>      
                        </div>                
                    </el-link>
                    <el-link :underline="false" @click="doAccount()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-zongshu" font-size="27px;"/>
                            <span class="txt">{{msg('统计')}}</span>
                        </div>
                    </el-link>
                    <el-link :underline="false" @click="buy()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-huowucaigou" font-size="27px;"/>
                            <span class="txt">{{msg('采购')}}</span>
                        </div>            
                    </el-link>
                    <el-link :underline="false" @click="stockDetail()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-yulan" font-size="27px;"/>
                            <span class="txt">{{msg('预览详情')}}</span>
                        </div>            
                    </el-link>
                    <el-link :underline="false" @click="updateInnerCode()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-kuaidiguanli" font-size="27px;"/>
                            <span class="txt">{{msg('快递单号')}}</span>
                        </div>            
                    </el-link>
                    <el-link :underline="false" @click="updatePurchaseCode()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-procurement-copy" font-size="27px;"/>
                            <span class="txt">{{msg('采购单号')}}</span>
                        </div>            
                    </el-link>
                    <el-link :underline="false" @click="updateRemark(2)">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-bianji" font-size="27px;"/>
                            <span class="txt">{{msg('货单备注')}}</span>
                        </div>            
                    </el-link>
                    <el-link :underline="false" @click="updateRemark(1)">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-xiugai" font-size="27px;"/>
                            <span class="txt">{{msg('报单备注')}}</span>
                        </div>
                    </el-link>
                    <!-- 
                    <el-link :underline="false" @click="addDetail()">
                        <div class="wrap" >
                            <i class="iconfont icon-jiajianfen font22" ></i>
                            <span class="txt">{{msg('新增详情')}}</span>
                        </div>
                    </el-link>
                    <el-link :underline="false" @click="deleteDetail()">
                        <div class="wrap" >
                            <i class="iconfont icon-huodongguanli font22" ></i>
                            <span class="txt">{{msg('删除详情')}}</span>
                        </div>
                    </el-link>
                    -->
                    <el-link :underline="false" @click="doExport()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-daochu2" font-size="27px;"/>
                            <span class="txt">{{msg('导出')}}</span>
                        </div>
                    </el-link>
                </div>
            </template>
        </ctrl-box>
 
        <div class="table-wrap">
            <vxe-grid ref="dataTable" :height="docHeight" 
                export-config
                resizable border="full"
                size="medium"
                align="center"
                :cell-style="{width:'80px;',height:'80px'}"
                show-overflow highlight-hover-row
                highlight-current-row highlight-hover-column highlight-current-column
                :data="stockDetails"
                :span-method="mergeRowMethod"
                :columns="columns"
                @cell-click="checkRow"
            ></vxe-grid>
        </div>

        <el-dialog :title="msg('查看订单')" :visible.sync="viewVisible" :fullscreen="isMinScreen" @opened="openedView"
            :close-on-click-modal="false" 
                width="850px">
            <buy-view ref="viewRef" :ids="detailIds" @close-dg="closeViewDg" />
        </el-dialog>

        <summary-detail ref="SummaryDetailRef" :is-min-screen="isMinScreen"/>
        <update-inner-exp-code-dialog ref="UpdateInnerExpCodeDialogRef" @finish="list"/>
        <update-purchase-code-dialog ref="UpdatePurchaseCodeDialogRef" @finish="list"/>
        <buy-dialog ref="BuyDialogRef"/>

        <add-stock-detail-dialog ref="AddStockDetailDialogRef" @finish="list"/>
        <!--采购弹窗-->
        <stock-detail-purchase ref="purchasDg" :stocks="selectedStocks" @finish="list"/>
    </div>  
</template>
<script>

import CtrlBox from "../../components/CtrlBox.vue";
import UpdateInnerExpCodeDialog from "../order/UpdateInnerExpCodeDialog.vue"
import UpdatePurchaseCodeDialog from "../order/UpdatePurchaseCodeDialog.vue"
import BuyDialog from "../order/BuyDialog.vue"

import OrderService from "../order/OrderService";
import SummaryDetail from "../order/SummaryDetail.vue";
import AddStockDetailDialog from "../order/AddStockDetailDialog.vue";
import StockDetailPurchase from "../store/StockDetailPurchase.vue";
export default {
    name: 'StockDetailBuy',
    components:{
        CtrlBox: CtrlBox,

        SummaryDetail : SummaryDetail,
        UpdateInnerExpCodeDialog: UpdateInnerExpCodeDialog,
        UpdatePurchaseCodeDialog: UpdatePurchaseCodeDialog,
        BuyDialog: BuyDialog,
        AddStockDetailDialog: AddStockDetailDialog,
        StockDetailPurchase:StockDetailPurchase
    },
    mounted:function(){
        this.init();
    },
    data(){
        return {
            showQuery: false,
            curr: null,
            columns: [],
            stockDetails: [],
            viewVisible:false,
            detailIds:null,
            ids: null,
            innerCodeVisible:false,
            innerCodePara:null,
            options:[
                {label:'淘宝',value:'taobao'},
                {label:'1688',value:'alibaba'},
                {label:'拼多多',value:'pdd'},
            ],
            addStockId:null,
            checkId:null,
            selectedStocks: null,
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
            return this.$store.state.isMinScreen;
            }
        },
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
    },
    methods: {
        init(){
            this.ids = window.localStorage.getItem("viewDetailIdsNew");
            this.buildColumns();
            this.list();
        },
        buildColumns(){
            this.columns = [
                {type: 'checkbox', minWidth: 40,},
                {field: 'id', title: this.msg('ID'), minWidth: 60, sortable: true},
                {field: 'code', title: this.msg('订单编号'), minWidth: 160, sortable: true,
                    filters:[{data: null}],
                    filterRender:{name: 'FilterInput'}
                },
                {field: 'productThumb', title: this.msg('商品图'), width: 120, sortable: true,
                    slots: {
                        default: ({ row }) => {
                            let thumb = row.productThumb
                            return thumb?[
                                <el-image  style="width: 80px;height:80px" src={this.$kit.api.imgView+thumb} preview-src-list={[this.$kit.api.imgView+thumb]}></el-image>
                            ]: [thumb];
                        },
                    }
                },
                { title: this.msg('操作'), width: 130,
                    slots: {
                        default: ({ row }) => {
                            return [
                                    <span class="id-cell1"><i class="add-cell el-icon-circle-plus-outline">新增</i></span>,
                                    <span class="id-cell2"><i class="delete-cell el-icon-delete">删除</i></span>,
                                    <br/>,
                                    // <i class="delete-cell el-icon-delete"><vxe-button type="text" icon="el-icon-delete">删除</vxe-button></i>
                                ]
                        },
                    }
                },
                {field: 'status', title: this.msg('货态'), minWidth: 80, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'},
                    slots: {
                            default: ({ row }) => {
                                let type = this.dicts.stockStatus.find(d => d.value === row.status);
                                return [
                                    <el-tag type={type?type.type:''}>{type?type.label:row.status}</el-tag>
                                ];
                            },
                        }
                },
                {field: 'innerExpCode', title: this.msg('快递单号'), minWidth: 160, sortable: true,
                    filters:[{data: null}],
                    filterRender:{name: 'FilterInput'},
                    slots: {
                            default: ({ row }) => {
                                return [
                                    <span>{row.innerExpCode}</span>,
                                    <br/>,
                                    <span>{row.shelfCode}</span>
                                ];
                            },
                        }
                },
                {field: 'purchaseStatus', title: this.msg('采购状态'), minWidth: 120, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'},
                    slots: {
                            default: ({ row }) => {
                                let type = this.dicts.purchaseStatuses.find(d => d.value === row.purchaseStatus);
                                return [
                                    <el-tag type={type?type.type:''}>{type?type.label:row.purchaseStatus}</el-tag>
                                ];
                            },
                        }
                },
                {field: 'hasLink', title: this.msg('链接'), minWidth: 60,sortable: true,
                    slots: {
                            default: ({ row }) => {
                                return [
                                    row.hasLink==1?<i class="el-icon-link"></i>:""
                                ];
                            },
                        }
                },
                {field: 'purchaseCode', title: this.msg('采购单号'), minWidth: 120, sortable: true,
                    filters:[{data: null}],
                    filterRender:{name: 'FilterInput'},
                    slots: {
                            default: ({ row }) => {
                                return [
                                    <span>{row.purchaseCode}</span>,
                                    <br/>,
                                    <span>{row.purchasePlatform}</span>
                                ];
                            },
                        }
                },
                {field: 'remark1', title: this.msg('货单/报单备注'), minWidth: 160, sortable: true,
                    filters:[{data: null}],
                    filterRender:{name: 'FilterInput'},
                    slots: {
                            default: ({ row }) => {
                                return [
                                    <span style="color: #67C23A">{row.remark1}</span>,
                                    <br/>,
                                    <span style="color: #F56C6C">{row.remark2}</span>
                                ];
                            },
                        }
                },
                {field: 'shopSellerMsg', title: this.msg('买家/卖家备注'), minWidth: 120, sortable: true,
                    filters:[{data: null}],
                    filterRender:{name: 'FilterInput'},
                    slots: {
                            default: ({ row }) => {
                                return [
                                    <span>{row.shopSellerMsg}</span>,
                                    <br/>,
                                    <span>{row.note}</span>
                                ];
                            },
                        }
                },
                {field: 'productQty', title: this.msg('数量'), minWidth: 60, sortable: true,
                    filters:[{data: {type: 'has', isCase: false, name: ''}}],
                    filterRender:{name: 'FilterComplex'},
                    slots: {
                            default: ({ row }) => {
                                return [
                                    <span>{row.productQty}</span>,
                                    <br/>,
                                    <span>${row.productPrice?(row.productPrice*0.01).toFixed(2):0}</span>
                                ];
                            },
                        }
                },
                {field: 'sku', title: this.msg('SKU'), minWidth: 120, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'},
                },
                {field: 'variationSku', title: this.msg('货号'), minWidth: 120, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'},
                },
                {field: 'productSpec', title: this.msg('规格'), minWidth: 90, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'},
                },
                {field: 'productTitle', title: this.msg('商品标题'), minWidth: 90, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'},
                },
                {field: 'detailQty', title: this.msg('品类'), minWidth: 60, sortable: true,
                    filters:[{data: {type: 'has', isCase: false, name: ''}}],
                    filterRender:{name: 'FilterComplex'}
                },
                {field: 'created', title: this.msg('下单时间'), minWidth: 120, sortable: true,
                    filters:[{data: []}],
                    filterRender:{name: 'ElDatePicker', props: {type: 'daterange', rangeSeparator: '至', startPlaceholder: '开始日期', endPlaceholder: '结束日期'}}
                },
                {field: 'shopDayToShip', title: this.msg('最后出货时间'), minWidth: 130, sortable: true,
                    filters:[{data: []}],
                    filterRender:{name: 'ElDatePicker', props: {type: 'daterange', rangeSeparator: '至', startPlaceholder: '开始日期', endPlaceholder: '结束日期'}}
                },
            ]
        },
        list(){
            this.$axios.post(this.$kit.api.stockDetail.detailBuyList, {ids:this.ids})
                .then((result) => {
                    if(result.status){
                        this.stockDetails = result.data;
                        // this.query.pageTotal = result.data.total;
                    }else{
                        this.$message(result.msg || this.msg('获取失败'));
                    }
                });
        },
        //点击行，选中行
        checkRow({row,rowIndex, $event, column, columnIndex}){
            //如果点击checkbox 则不处理
            let className = $event.target.className;
            // console.log(className);
            if(columnIndex > 0){  //选择 
                var table =  this.$refs.dataTable;
                table.setCheckboxRow([row], !table.isCheckedByCheckboxRow(row))
            }
            if(className.indexOf('add-cell') > -1){
                this.addDetail(row);
            }
            if(className.indexOf('delete-cell') > -1){
                this.deleteDetail(row);
            }
        },
        reset(){
            this.$kit.clearQuery(this.query);
        },
        doExport(){
            this.$refs.dataTable.openExport({ isPrint: false })
        },
        //分页数据发生改变，回调事件：info[0]: 每页显示的数量，info[1]: 起始页
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            this.list();
        },
        accetReport(){//报单受理
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            let ids = '';
            selectes.forEach(e => {
                ids += e.ids+',';
            });
            this.$confirm('是否确认受理?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post(this.$kit.api.stock.acceptReport, ids)
                .then((result) => {
                    if(result.status){
                        // let data = result.data;
                        // selectes.forEach(e => {
                        //     e.batch = data.batch;
                        // });
                        this.list();
                        this.$message(this.msg('受理成功'));
                    }else{
                        this.$message(this.msg('受理失败'));
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消'
                });          
            });
        },
        cancelReport(){//撤销受理
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            let ids = '';
            selectes.forEach(e => {
                ids += e.ids+',';
            });
            this.$confirm('是否确认撤销受理?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post(this.$kit.api.stock.cancelReport, ids)
                .then((result) => {
                    if(result.status){
                        // let data = result.data;
                        // selectes.forEach(e => {
                        //     e.batch = '';
                        // });
                        this.list();
                        this.$message(this.msg('撤销成功'));
                    }else{
                        this.$message(this.msg('撤销失败'));
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消'
                });          
            });
        },
        stockView(row){//查看订单
            this.detailIds = row.ids;
            this.viewVisible = true;
        },
        openedView(){
            this.$nextTick(() => {
                this.$refs.viewRef.init();
            });
        },
        closeViewDg(){
            this.viewVisible = false;
        },
        updateMark(row){//点到
            this.$axios.post(this.$kit.api.stock.updateMark, row.ids)
                .then((result) => {
                    if(result.status){
                        row.mark = 1;
                        this.$message(result.msg || this.msg('更新成功'));
                    }else{
                        this.$message(result.msg || this.msg('更新失败'));
                    }
                });
        },
        doAccount(){//统计
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            // let count = DetailBuyService.summary(selectes);
            this.$refs.SummaryDetailRef.doSummary(selectes);
        },
        // 通用行合并函数（将相同多列数据合并为一行）
        mergeRowMethod ({ row, _rowIndex, column, visibleData }) {
            const fields = ['code']
            const cellValue = row[column.property]
            if (cellValue && fields.includes(column.property)) {
            const prevRow = visibleData[_rowIndex - 1]
            let nextRow = visibleData[_rowIndex + 1]
            if (prevRow && prevRow[column.property] === cellValue) {
                return { rowspan: 0, colspan: 0 }
            } else {
                let countRowspan = 1
                while (nextRow && nextRow[column.property] === cellValue) {
                nextRow = visibleData[++countRowspan + _rowIndex]
                }
                if (countRowspan > 1) {
                return { rowspan: countRowspan, colspan: 1 }
                }
            }
            }
        },
        //预览详情
        stockDetail(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            let ids = selectes.map(e => e.stockId).join(",");
            window.localStorage.setItem("viewDetailIds", ids);
            this.$tabs.open("/admin/stock/stock-detail");
        },
        buy(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            //通过sku、货号去匹配采购链接，如果获取到则直接跳转
            this.selectedStocks = selectes.map(s => {return {stockId: s.stockId, detailId: s.id, qty: s.productQty}});
            OrderService.concatPurchaseLink(selectes).then((links) => {
                if(links.length == 1){
                    window.open(links[0], "_blank");
                    this.$refs.purchasDg.showDialog();
                    return;
                }
                this.$refs.BuyDialogRef.checkNeedBuy(selectes,false, ()=>{
                    this.selectedStocks = selectes.map(s => {return {stockId: s.stockId, detailId: s.id, qty: s.productQty}});
                    this.$refs.purchasDg.showDialog();
                });
            });
        },
        //快递单号
        updateInnerCode(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            this.$refs.UpdateInnerExpCodeDialogRef.showDialog(selectes);
        },
       
        //采购单号
        updatePurchaseCode(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            this.$refs.UpdatePurchaseCodeDialogRef.showDialog(selectes);
        },
        //货单备注/报单备注
        updateRemark(type){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            OrderService.updateRemark(type, selectes, this.list);
        },
        //新增详情
        addDetail(row){
            /*
            let status = row.status;
            this.addStockId = row.stockId;
            if(!this.hasPermission("stock:detailEdit")){
                this.$message(this.msg('无操作权限'));
                return;
            }
            if(status >= 13 && status <= 23 && status != 20){
                this.addDetailVisiable = true;
            }else{
                if(this.hasPermission("stock:detailAdd")){
                    this.addDetailVisiable = true;
                }else{
                    this.$message(this.msg('该订单不能新增'));
                }
            }
            */
            this.$refs.AddStockDetailDialogRef.showDialog(row);
        },
        //删除详情
        deleteDetail(row){
            OrderService.deleteDetail(row, this.list)
        },
    },
}
</script>

<style lang="scss" scoped>
.add-cell{cursor:pointer; display:inline-block; margin-right:10px;}
.delete-cell{cursor:pointer; display:inline-block; margin-right:10px;}
.view-cell{cursor:pointer; display:inline-block; margin-right:1px;}
.view-edit{cursor:pointer; display:inline-block;}
.mark-cell{cursor:pointer; display:inline-block;color:red;margin-right: 5px;}
.remove-cell{cursor:pointer; display:inline-block; color:red;}
</style>
